/*eslint-disable*/
import Flickity from 'flickity'


export default beachSlider => {
   const slideshow = beachSlider.querySelector('.js-beach-slider')
   if (slideshow) {
     const flkty = new Flickity(slideshow, {
       contain: true,
       wrapAround: true,
       pageDots: false,
       prevNextButtons: false,
       autoPlay: 4000
     })

  flkty.on('dragStart', (event, pointer) => { document.ontouchmove = e => e.preventDefault() })
  flkty.on('dragEnd', (event, pointer) => { document.ontouchmove = e => true })
  
     flkty.on('change', (index) => {
      setTimeout(() => {
        flkty.playPlayer()
      }, 10000)
    })

     setTimeout(() => {
       flkty.resize()
     }, 1500)

   }
}


// WEBPACK FOOTER //
// ./src/scripts/components/beach-slider.js